import { Component, ViewChild, ElementRef, OnInit, Inject, Optional, Renderer2, ChangeDetectionStrategy } from '@angular/core';

import { MatButtonModule } from '@angular/material/button';
import { MatDialog, MatDialogActions, MatDialogContent, MatDialogRef, MatDialogTitle, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormArray, FormGroup, FormControl, FormBuilder, AbstractControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgClass, DatePipe, JsonPipe } from '@angular/common';
import {  ITreeNode } from '@app/shared/_models/common';
import { QuotationService } from '@app/sales/quotation/quotation.service';
import { SpinnerService } from '@app/shared/spinner.service';
import { CommonService } from '@app/common/common.service';
import { AlertService } from '@app/shared/alert.service';
import { Product } from '@app/shared/_models/product';
import * as constants from "@app/shared/constants";
import { IProductConfig, Sales_order_l } from '@app/shared/_models/sales';
import { filter, fromEvent, Subscription } from 'rxjs';
import { SmartSelectComponent } from '@app/shared/smart-select/smart-select.component';


@Component({
    selector: 'app-configuration',
    imports: [JsonPipe, MatButtonModule, MatDialogActions, MatDialogTitle, MatDialogContent, FormsModule, ReactiveFormsModule, SmartSelectComponent],
    templateUrl: './configuration.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './configuration.component.scss'
})
export class ConfigurationComponent {
	public tree: ITreeNode[] | undefined;
	public components: ITreeNode[] | undefined;
	public rootNode: ITreeNode | undefined;
	public productname: string="";
	selectedSectionProductIds = new Set<number>();
  // public sales_order_lines: Sales_order_l[] = [] ;
  public parent_line!: Sales_order_l ;
  public C_CUF_CONFIGURATION_VALUE = constants.C_CUF_CONFIGURATION_VALUE.toString();
  public C_CUF_CONFIGURATION = constants.C_CUF_CONFIGURATION.toString();
  private removeKeyListener?: () => void;
  
  
	public formgroup = this.fb.group({
		// configuration_path: this.fb.control(null),
		cufs : this.fb.group({
      [this.C_CUF_CONFIGURATION]: this.fb.control(null),
      [this.C_CUF_CONFIGURATION_VALUE]: this.fb.array([])
    })
	});

	constructor( private renderer: Renderer2 ,   private spinner: SpinnerService,public commonService: CommonService, private alert: AlertService, @Optional() public dialogRef: MatDialogRef<ConfigurationComponent>, @Optional() @Inject(MAT_DIALOG_DATA) public dialogData: any, private quotationservice: QuotationService, private fb:FormBuilder) { }

	ngOnInit() {
    console.log('this.dialogData=', JSON.stringify( this.dialogData ) , this.dialogData  );
    this.parent_line = this.dialogData.parent_line
    if( !this.parent_line || !this.parent_line.seq ){ this.onCancel() }  // si on a pas de seq issu du parent on se casse
    console.log('value of parent_line =  ' , this.parent_line  );

		this.commonService.getTree(this.dialogData.configpath).subscribe({
			next: (tree: ITreeNode[]) => {
				this.tree = tree;
        console.log('tree',tree);
        
        // tree est un arbre a plat dans un array sans récurcivité donc on utilise d'abord le path pour pour connaitre la racine
        // // ensuite les branches ayant +1 sur le nlevel sont un rang en dessous de le racine et ainsi de suite. 
				this.rootNode = tree.find((node) => node.path === this.dialogData.configpath);
				if (this.rootNode) {
          // console.log('rootnode=', JSON.stringify( rootnode ) , rootnode  );
					this.productname = this.rootNode.name;
				// this.rootNode = rootnode;
					// this.formgroup.controls["configuration_path"].setValue(this.dialogData.configpath);	
         ( (this.formgroup.get('cufs') as FormGroup).get(this.C_CUF_CONFIGURATION) as FormGroup).setValue(this.dialogData.configpath);	 // ici on cré le data: { cuf: {-1 : 'onfig.configlit' } } 
          this.components = this.tree.filter((node) => node.nlevel == this.rootNode!.nlevel + 1); // on cré un form group par composant enfant de la racine les composant enfant seront les valeurs possible pour les select donc uniquement ceux qui on un level +1 par rapport à la racine
          // console.log('this.components=', JSON.stringify( this.components ) , this.components  );
					this.components.map((node,i)=> {
						const group = this.fb.group<IProductConfig>({
							id_node: node.id,
							name: node.name,
							path: node.path,
							nlevel: node.nlevel,
              seq: (this.getDialogDataValue(node.id)?.seq ?? (  this.parent_line.seq! + i +1   ) ),
              // ici on stock dans lnk_node_order_val et lnk_product l'intégralité objet en jointure alors qu'après on ne stockera que la clé primaire la raison de ce choix est que dans le form groupe j'ai accès au nom de la propriété pour l'afficher et plus tard à l'id pour l'enregistrer
              lnk_node_order_val: this.tree!.find( el => el.id ===  this.getDialogDataValue(node.id)?.order_node   ) ??  ( this.getTreeFromPath(node.path , node.nlevel + 1).length === 1 ? this.getTreeFromPath(node.path , node.nlevel + 1)[0] :undefined ) , 
							lnk_product: this.getProductsFromTreeNodeId(node!)?.find(el => el.id === this.getDialogDataValue(node.id)?.product   ) , 
						});
            this.configuration .push(group);
					})
          // console.log( this.configuration.value  );
				} else {
					// TODO Inconsistency
					console.error("Tree inconsistency");
				}
			},
			error: (e) => {
				console.log("ERREUR Serveur : ", e.error);
				this.spinner.hide();
				this.alert.error("ERREUR Serveur : " + e.error);	// TEMPLATE subscribe call
			}
		});

	}


  ngAfterViewInit(): void {
    setTimeout(() => { // this delay ensures the view is fully and we are after the stack of angular initialization 
      this.removeKeyListener = this.renderer.listen('document', 'keydown', (event: KeyboardEvent) => {   // Installer le listener quand les ViewChild sont prêts after a little delay setTimeout 
        const active = document.activeElement;

         if ((event.key ==='Enter' || event.key ==='NumpadEnter' )  ) { // on valide le formulaire uniquement si il est valide
          console.log(' salut from enter key');
          event.stopPropagation(); 
          event.preventDefault(); 
          this.onOk();
          // if (document.activeElement === this.packagingSelectCmp?._elementRef.nativeElement ) { this.packagingSelectCmp?.open(); }  // TODO solution mauvaise n'ayant pas réussi à détecter le enter dans le select le panel se ferme or il doit impérativement rester ouvert quand on a le focus sinon gros bug avec la flèche gauche (comportement hasardeux)
          // this.formgroup.controls['ProductPackagingVal'].setValue( this.formgroup.controls['ProductPackagingVal'].getRawValue()  ); // to be sure the value is updated
        } 

        else { 
          event.preventDefault(); 

        } // on bloque toute autre touche

      });  // fin listener
    },100); // fin setTimeout  utilisé pour être sûr d'être après le cycle d'init d'angular


  } 







	onCancel() {
		this.dialogRef.close(undefined);							// Cancel => Return undefined
	}
	
	toggleSectionProduct(id: number): void {
		if (this.selectedSectionProductIds.has(id)) { this.selectedSectionProductIds.delete(id); }
		else { this.selectedSectionProductIds.add(id); }
	}

	isSectionProductSelected(id: number): boolean {
		return this.selectedSectionProductIds.has(id);
	}

	onOk() {
    // console.log('this.formgroup.value=', JSON.stringify( this.formgroup.value ) , this.formgroup.value  );
		const selectedSectionProducts = Array.from(this.selectedSectionProductIds)
			.map(id => this.getProductInfo(id)).filter(p => !!p);
		this.dialogRef.close({ ...this.formgroup.value, selectedSectionProducts });
	}
	
	onSelectChange(index:number, _e:any) {	// Unused
		console.log("[onSelectChange] index: " + index);
		this.commonService.getTree(this.dialogData.configpath, 0).subscribe({});
	}
	
  nullableNodeLabel = (item: any) => item?.name ?? '-';

  getTreeFromPathWithNull(path: string, nlevel: number): any[] {
	// console.log('this.getTreeFromPath(path, nlevel)',this.getTreeFromPath(path, nlevel));
    return [null, ...this.getTreeFromPath(path, nlevel)];
  }

  onNodeOrderChange(node:AbstractControl<any, any>){
    node.get('lnk_product')?.setValue(null);
    console.log('value of node.value =  ' , node.value  );
  }

	getTreeFromPath(path:string, nlevel: number):ITreeNode[] {	// Get tree node from parent path and level (do not include parent)
		// console.log(nlevel);
		// console.log(this.tree?.filter ((node) => {console.log (node.path + " " + path + "\nlevel: " + node.nlevel); return node.path.startsWith(path+'.') && node.nlevel == nlevel}));
		return this.tree?.filter ((node) => node.path.startsWith(path+'.') && node.nlevel == nlevel)?? [] ;
	}	
	
	getTreeFromId(id_node:number):ITreeNode[]|undefined {	// Get tree node from parent id (do not include parent)
		let parent:ITreeNode|undefined = this.tree?.find ((node) => node.id==id_node); 
		return this.tree?.filter ((node) => node.path.startsWith(parent?.path+'.'));
	}	
	
  getProductsFromTreeNodeIdWithNull(node: ITreeNode): any[] {
	// console.log('this.getProductsFromTreeNodeId(node)',this.getProductsFromTreeNodeId(node));
    return [null, ...(this.getProductsFromTreeNodeId(node) ?? [])];
  }

  getProductsFromTreeNodeId(node:ITreeNode):Product[]|undefined {	// Get products from tree node id
    if(node && node.id){
      let parent:ITreeNode|undefined = this.tree?.find ((node_el) => node_el.id==node.id); 
      let child_tree_leaf = this.tree?.filter ((node) => node.path.startsWith(parent?.path+'.') ) ?? [];
      return child_tree_leaf.flatMap((node) => node.lnk_products ??[] );
    }
    return undefined;
  }	
	


	getProductInfo(id: number): any {
		return this.rootNode?.lnk_products?.find(p => p.id === id);
	}

	getDialogDataValue(id_node:number):any { // a l'ouverture du dialog on envoi dialogData avec une propriété value qui est un array ici on récupère la valeur pour un form 
    let v =this.dialogData?.parent_line?.data?.cufs[constants.C_CUF_CONFIGURATION_VALUE.toString()]?.filter((v:any) => v.id_node == id_node);
		return (v && v.length ? v[0] : undefined);
	}

	get configuration() {
		// console.log('(this.formgroup.get(cufs) as FormGroup).get(this.C_CUF_CONFIGURATION_VALUE) as FormArray ',(this.formgroup.get('cufs') as FormGroup).get(this.C_CUF_CONFIGURATION_VALUE) as FormArray );
	  return (this.formgroup.get('cufs') as FormGroup).get(this.C_CUF_CONFIGURATION_VALUE) as FormArray 
	}		
	

  ngOnDestroy() {
    // Nettoyage pour éviter les fuites mémoire

    if (this.removeKeyListener) {
      this.removeKeyListener();
      this.removeKeyListener = undefined; // optionnel, pour éviter de l’appeler deux fois
    }
  }



















}
